import { ControlFacet } from '../models/controls/ControlFacet';

export const targetWindowControl = new ControlFacet<{}, {
  targetWindow: Window;
}>('targetWindowControl');
